import "./SinglePostTemplate.module.css"
import Encabezado from "@/reusable_sections/Header"
import SinglePostTemplateSection from "./sections/SinglePostTemplateSection"
import PieDePA_gina from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <Encabezado />
      <SinglePostTemplateSection />
      <PieDePA_gina />
    </div>
  )
}
